import Service from '../service.js';
import Pagination from '@/components/pagination/index.vue';
import { successMessage, errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableList: [],
      showDialog: false,
      quikPayFlag: 1, // 是否开通快捷支付，1未开通2开通
      quikPayFlagList: [
        {id: 1, code: '1', value: '未开通'},
        {id: 2, code: '2', value: '已开通'},
        {id: 3, code: '3', value: '处理中'}
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'isHeilongjiang'])
  },
  created() {
    this.getBankList();
  },
  methods: {
    // 获取银行卡列表
    getBankList(){
      Service.getBankList().then(res => {
        if (res && res.code === '0') {
          this.tableList = res.data;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 删除
    deleteBank() {
      this.$confirm('是否确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isAllowModify().then(res => {
          if (res) {
            Service.deleteBank(bankId).then(res => {
              if (res && res.code === '0') {
                successMessage('删除成功');
                this.getBankList();
              }
            });
          }
        });
      });
    },
    // 设为默认
    setDefaultFlag(bankId) {
      Service.updateAccountDefaultFlag(bankId).then(res => {
        if (res && res.code === '0') {
          successMessage('设置成功');
          this.getBankList();
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    addBank(bankId, pageName = 'add') {
      let tabLen = this.tableList.length;
      // 村集体
      if (this.userInfo.type === 3) {
        tabLen = this.tableList.filter(item => item.status !== 91).length;
      }
      if (pageName === 'add' && tabLen >= 5) {
        errorMessage('最多添加5个银行账户，可先删除后再添加。');
      } else {
        if (pageName === 'modify') {
          this.isAllowModify().then(res => {
            if (res) {
              this.$router.push({path: `/person-center/account-info/bank-account-manage/${pageName}`, query: { bankId }});
            }
          });
          return;
        }
        this.$router.push({path: `/person-center/account-info/bank-account-manage/${pageName}`, query: { bankId }});
      }
    },

    isAllowModify() {
      return new Promise((resolve, reject) => {
        Service.validateBankAccount().then(res => {
          if (res && res.code === '0') {
            resolve(true);
          } else {
            errorMessage(res && res.reason);
            reject(false);
          }
        }, error => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          }
          reject(false);
        });
      });
    },
    goToDetail (bankId) {
      this.$router.push({path: '/person-center/account-info/bank-account-manage/detail', query: { bankId }});
    },
    ruleShow(quikPayFlag) {
      this.quikPayFlag = quikPayFlag;
      this.showDialog = true;
    }
  }
};
